import { MdClose } from 'react-icons/md';

const ErrorModal = (props: { isOpen: any; onClose: any }) => {
    const { isOpen, onClose } = props;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/30 backdrop-blur-sm">
            <div className="relative z-[1002] w-full max-w-[500px] p-4">
                <div className="relative rounded-xl border border-leadrs-stroke bg-white px-8 py-10 shadow-lg">
                    <button className="absolute right-4 top-4" onClick={onClose}>
                        <MdClose size={20} className="text-leadrs-text-soft hover:text-leadrs-text transition-colors" />
                    </button>
                    <p className="text-center font-crimson text-2xl font-semibold text-leadrs-text">
                        Demande en attente
                    </p>
                    <p className="mt-5 text-center font-geist text-sm text-leadrs-text-soft">
                        Nous vous remercions pour votre demande, mais celle-ci ne peut pas être prise en compte pour le moment.
                    </p>
                    <p className="mt-3 text-center font-geist text-sm text-leadrs-text-soft">
                        Pour pouvoir poster votre annonce, il est nécessaire de{' '}
                        <span
                            className="cursor-pointer font-semibold text-leadrs-brand hover:underline"
                            onClick={() => (window.location.href = '/subscribe')}
                        >
                            souscrire à un abonnement
                        </span>{' '}
                        payant ou d&apos;utiliser un code de parrainage. N&apos;hésitez pas à nous contacter si vous avez des questions.
                    </p>
                    <button
                        className="mx-auto mt-6 flex rounded-xl bg-leadrs-brand px-6 py-3 font-geist text-sm font-medium text-white hover:opacity-80 transition-opacity"
                        onClick={() => (window.location.href = '/subscribe')}
                    >
                        Je m&apos;abonne maintenant
                    </button>
                    <p className="mt-4 text-center font-geist text-sm text-leadrs-text-soft">
                        L&apos;équipe Leadrs
                    </p>
                </div>
            </div>
        </div>
    );
};
export default ErrorModal;
